"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.search");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _auth = require("@/utils/auth");

var _button_pagination = _interopRequireDefault(require("@/views/widgets/button_pagination.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    ButtonPagination: _button_pagination.default
  },
  data: function data() {
    return {
      role: {},
      search: '',
      category_id: null,
      loading: false
    };
  },
  computed: {
    bulletins: function bulletins() {
      return this.$store.getters.bulletins;
    },
    currentPage: function currentPage() {
      return this.$store.getters.pageBulletinCount;
    },
    maxPage: function maxPage() {
      return this.$store.getters.pageBulletinTotal;
    },
    bulletinCategories: function bulletinCategories() {
      return this.$store.getters.bulletinCategories;
    }
  },
  beforeMount: function () {
    var _beforeMount = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var roleType;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              this.$store.commit('bulletin/setBulletinCount', 0);
              this.$store.commit('bulletin/setOptionValue', 2);
              this.$store.commit('bulletin/setCategoryId', null);
              this.$store.commit('bulletin/setSearchText', null);
              _context.next = 7;
              return this.$store.dispatch('bulletin/getBulletinList');

            case 7:
              _context.next = 9;
              return this.$store.dispatch('bulletin/getBulletinCategories');

            case 9:
              _context.next = 11;
              return (0, _auth.getUserPermission)();

            case 11:
              roleType = _context.sent;

              if (roleType) {
                this.role = JSON.parse(roleType);
              }

              this.loading = false;

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeMount() {
      return _beforeMount.apply(this, arguments);
    }

    return beforeMount;
  }(),
  methods: {
    handleSearch: function () {
      var _handleSearch = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$store.commit('bulletin/setCategoryId', this.category_id);
                this.$store.commit('bulletin/setSearchText', this.search);
                this.$store.commit('bulletin/setBulletinCount', 0);
                _context2.next = 5;
                return this.$store.dispatch('bulletin/getBulletinList');

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSearch() {
        return _handleSearch.apply(this, arguments);
      }

      return handleSearch;
    }(),
    goToDetail: function goToDetail(data) {
      this.$router.replace({
        name: 'BulletinEdit',
        params: {
          surveyId: data.id
        }
      });
    },
    goTopPage: function () {
      var _goTopPage = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.$store.commit('bulletin/setBulletinCount', 0);

              case 2:
                _context3.next = 4;
                return this.$store.dispatch('bulletin/getBulletinList');

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function goTopPage() {
        return _goTopPage.apply(this, arguments);
      }

      return goTopPage;
    }(),
    goPrePage: function () {
      var _goPrePage = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var pre;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.currentPage;

              case 2:
                pre = _context4.sent;

                if (!(pre > 0)) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 6;
                return this.$store.commit('bulletin/setBulletinCount', pre - 1);

              case 6:
                _context4.next = 8;
                return this.$store.dispatch('bulletin/getBulletinList');

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function goPrePage() {
        return _goPrePage.apply(this, arguments);
      }

      return goPrePage;
    }(),
    goNextPage: function () {
      var _goNextPage = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5() {
        var next, total;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.currentPage;

              case 2:
                next = _context5.sent;
                _context5.next = 5;
                return this.maxPage;

              case 5:
                total = _context5.sent;

                if (!(next < total)) {
                  _context5.next = 11;
                  break;
                }

                _context5.next = 9;
                return this.$store.commit('bulletin/setBulletinCount', next + 1);

              case 9:
                _context5.next = 11;
                return this.$store.dispatch('bulletin/getBulletinList');

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function goNextPage() {
        return _goNextPage.apply(this, arguments);
      }

      return goNextPage;
    }(),
    goLastPage: function () {
      var _goLastPage = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.$store.commit('bulletin/setBulletinCount', this.maxPage);

              case 2:
                _context6.next = 4;
                return this.$store.dispatch('bulletin/getBulletinList');

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function goLastPage() {
        return _goLastPage.apply(this, arguments);
      }

      return goLastPage;
    }()
  }
};
exports.default = _default;